import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { TenantService } from '../tenant/tenant.service';

/**
 * Gates `/app/agency`. A non-admin (every individual, and a non-admin agency member) lands on the
 * shell's in-app access-denied card rather than bouncing out, matching domainAdminGuard's
 * treatment of a non-admin. A failed read denies rather than stranding the guard: a false negative
 * here just means a retry, where a false positive would expose agency-wide billing and team data.
 */
export const agencyAdminGuard: CanActivateFn = () => {
  const tenant = inject(TenantService);
  const router = inject(Router);

  return tenant.fetchMe().pipe(
    map((info) => (info.isAgencyAdmin ? true : router.createUrlTree(['/app/access-denied']))),
    catchError(() => of(router.createUrlTree(['/app/access-denied']))),
  );
};
